<template>
  <main>
    <div id="modal1" class="modal">
      <div class="modal-content">
        <h3 style="text-align: center">Querido usuario</h3>
        <p>
          En atención a sus opiniones, hemos decidido modificar está sección,
          ahora por defecto traerá la información de los últimos DOS meses, este
          intervalo podrá ser modificado según sea conveniente, esperamos esto
          ayude a mejorar la experiencia de usuario, cualquier tema seguimos a
          sus órdenes en los canales de siempre.
        </p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="waves-effect waves-light btn modal-close">Ok</a>
      </div>
    </div>
    <ModalVentas ref="modal">
      <h5 v-show="showMessageRange">
        * El rango entre la fecha inicial y la fecha final supera los 400
        días.
      </h5>
      <h5 v-show="showMessageOld">
        * La fecha inicial supera los 400 días de antiguedad.
      </h5>
    </ModalVentas>

    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas">
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class=" page-title">
            <span>Administrar Base</span>
          </div>
          <div >
            <span class="page-title"> {{ computedList.length }} encontrados</span>
          </div>
          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="col s6 m3 offset-m3 l2 offset-l4 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align " @click="dateIni">
            <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
            >today</span
            >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Inicial:</span
                >
              </div>
              <input
                  id="input-fecha-inicial"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>

            <div class="col s6 m3 l2 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align" @click="dateFin">
            <span
                class="material-symbols-outlined btn-style "
                style="position: relative; top: 4px;"
            >event</span
            >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Final:</span
                >
              </div>
              <input
                  id="input-fecha-final"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>
          </div>

        </div>

        <!--       <div class="s3 l10 offset-l1 button-box">
          <div
            class="button-box-int waves-effect waves-light btn-large #546e7a blue-grey darken-2"
            @click="traerIccsFechas(0, 0)"
          >
            <i class="material-icons">search</i>
          </div>
        </div> -->

        <div id="app">
          <div class="col s6 left-align"></div>
          <div class="col s6 right-align">
            <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                data-tooltip="Mostrar Filtros"
                v-if="mostrarFiltros == false"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span
                  class="material-symbols-outlined btn-style"

              >
              filter_alt_off
            </span>
            </div>
            <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                data-tooltip="Ocultar Filtros"
                v-if="mostrarFiltros == true"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span
                  class="material-symbols-outlined btn-style"

              >
              filter_alt
            </span>
            </div>
            <div
                class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="generarExcel"
                data-position="top"
                data-tooltip="Generar Excel"
            >
              <i class="fa fa-file-excel-o " aria-hidden="true"></i>

              <input
                  v-show="mostrarExcel"
                  id="input-fecha"
                  type="text"
                  placeholder="Fecha de expiracion"
                  class="datepickerFecha ancho-fecha"
                  style="width: 131px; right: 93px; position: absolute; top: 55px"
              />
            </div>
          </div>

          <div class="row" v-show="mostrarFiltros" v-if="!isBisvi">

            <div
                class="column col s6 m6 l2 xl2"
                v-for="titulo in titulos" v-if="!(empresa == 'discovery' && titulo.llave == 'monto' && !isAdmin)"

            >

              <div class="chips validate input-filtros" :id="titulo.llave">

                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
          <div class="row" v-show="mostrarFiltros" v-else>

            <div
                class="column col s6 m6 l2 xl2"
                v-for="titulo in titulosBisvi"

            >

              <div class="chips validate input-filtros" :id="titulo.llave">
                <!--               <i class="material-icons icon-chips">filter_list</i> -->
                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


      <form enctype="multipart/form-data" v-show="false" id="formulario">
        <input
            type="file"
            id="archivo"
            name="archivo"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </form>

      <div class="table col s12 l10 push-l1">
        <div class="">
          <table
              class="responsive-table striped highlight "
              style="text-align-last: center"
          >
            <thead v-if="!isBisvi">
            <tr>
              <th
                  v-for="titulo in titulos"
                  v-if="titulo.valor != 'plataforma' && !(empresa == 'discovery' && titulo.llave == 'monto' && !isAdmin)"
              >
                <p>{{ titulo.valor }}</p>
              </th>
              <th
                  v-for="titulo in titulos"
                  v-if="titulo.valor == 'plataforma' && isPlataforma && !(empresa == 'discovery' && titulo.llave == 'monto' && !isAdmin)"
              >
                <p>{{ titulo.valor }}</p>
              </th>
              <th v-if="fIsControler('administrarBase')">
                <p>Editar</p></th>
              <th v-if="permisoDesbloquear">
                <p>Desbloquear</p>
              </th>
            </tr>
            </thead>

            <thead v-else>
            <tr>
              <th
                  v-for="titulo in titulosBisvi"
                  v-if="titulo.valor != 'plataforma'"
              >
                <p>
                  {{ titulo.valor }}
                </p>
              </th>
              <th
                  v-for="titulo in titulosBisvi"
                  v-if="titulo.valor == 'plataforma' && isPlataforma"
              >
                <p>{{ titulo.valor }}</p>
              </th>
              <th v-if="fIsControler('administrarBase')">
                <p>Editar</p>
              </th>
              <th v-if="permisoDesbloquear">
                <p>Desbloquear</p>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(fila, index) in agregar100">
              <td v-show="fila.id !== filaEditar && !isEdit">
                <p>{{ fila.icc }}</p>
              </td>
              <td v-show="fila.id === filaEditar">
                <input type="text" v-model="iccEdit"/>
              </td>
              <td v-show="fila.id !== filaEditar && !isEdit">
                <p>{{ fila.dn }}</p>
              </td>
              <td v-show="fila.id === filaEditar">
                <input type="text" v-model="dnEdit"/>
              </td>
              <td v-show="(fila.id !== filaEditar && !isEdit) || !isMonto" v-if="!(empresa == 'discovery' && !isAdmin)">
                <p>${{ fila.monto }}</p>
              </td>
              <td v-show="fila.id === filaEditar && isMonto" v-if="!(empresa == 'discovery' && !isAdmin)">
                <input type="text" v-model="montoEdit"/>
              </td>
              <td v-show="fila.id !== filaEditar && !isEdit">
                <p>{{ fila.lider }}</p>
              </td>
              <td v-show="fila.id === filaEditar">
                <input type="text" v-model="liderEdit"/>
              </td>
              <td v-show="fila.id !== filaEditar && !isEdit">
                <p>{{ fila.cliente }}</p>
              </td>
              <td v-show="fila.id === filaEditar">
                <input type="text" v-model="clienteEdit"/>
              </td>

              <td>
                <p>{{ fila.compania }}</p>
              </td>
              <td>
                <p>{{ fila.subidoPor }}</p>
              </td>
              <td>
                <p>{{ fila.fechaSubida }}</p>
              </td>
              <td>
                <p>{{ fila.fechaActualizacion }}</p>
              </td>
              <td>
                <p>{{ fila.fechaVigencia }}</p>
              </td>
              <td>
                <p>{{ fila.fechaRecarga }}</p>
              </td>
              <td v-show="fila.id !== filaEditar && !isEdit">
                <p>
                  {{ fila.nir }}
                </p>
              </td>
              <td v-show="fila.id === filaEditar">
                <input type="text" v-model="nirEditar"/>
              </td>
              <td v-if="isPlataforma">
                <p>{{ fila.plataforma }}</p>
              </td>
              <td v-if="isBisvi">
                <p>{{ fila.fechaEntrega }}</p>
              </td>
              <td v-if="isBisvi">
                <p>{{ fila.producto }}</p>
              </td>
              <td v-if="isBisvi">
                <p>{{ fila.fechaPortada }}</p>
              </td>

              <!-- <td class="center-align"><i class="fa"
                                       :class="{fuenteVerde:(fila.isRecargado==='1'), 'fa-check':(fila.isRecargado==='1'), 'fa-times':(fila.isRecargado!=='1') ,fuenteRojo:(fila.isRecargado!=='1')}"
                                       aria-hidden="true"></i></td>-->
              <td>
                <p
                    class="center-align">
                  <i v-if="fIsControler('administrarBase')"
                     v-show="fila.id !== filaEditar && !isEdit"
                     class="fa fa-pencil-alt cursorOn"
                     @click="editar(fila)"
                     aria-hidden="true"
                  ></i>
                </p>

              </td>
              <td v-show="fila.id === filaEditar" @click="showModal('editarIcc', fila.id)"
                  class="fa fa-sync-alt fuenteVerde">
                <p class="center-align">
                  <i

                      aria-hidden="true"
                  ></i>
                </p>

              </td>
              <td v-if=" permisoDesbloquear &&
                    fila.isRecargado == '1' &&
                    fila.fechaRecarga == 'Sin fecha'">
                <p>
                  <i
                      class="material-icons cursorOn"
                      @click="desbloquear(fila.icc)"
                  >phonelink_lock</i>
                </p>

              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {creaExcel, getIccs, plataformaCarrier} from "@/api/api";
import {activateLine} from "@/api/iccs";
import {actualizarIcc, plataformasEmpresa, getEmpresas} from "@/api/api";
import {controles, i18n} from "@/constantes";
import ModalVentas from "./modalVentas.vue";
import {mapState} from "vuex";
import {emitter} from "@/eventBus";

let copyTitulos = [];
let datosEncontrados = 0;
let filtros = {};
let usuario;

export default {
  name: "administrarBase",
  data() {
    return {
      showMessageRange: false,
      showMessageOld: false,
      isEdit: false,
      titulo: "Cargando...",
      titulos: [
        {llave: "icc", valor: "Icc"},
        {llave: "dn", valor: "DN"},
        {llave: "monto", valor: "Monto"},
        {llave: "lider", valor: "Lider"},
        {llave: "cliente", valor: "Cliente"},
        {llave: "compania", valor: "compañia"},
        {llave: "subidoPor", valor: "Subido por"},
        {llave: "fechaSubida", valor: "Subida"},
        {llave: "fechaActualizacion", valor: "Actualizada"},
        {llave: "fechaVigencia", valor: "Vigencia"},
        {llave: "fechaRecarga", valor: "Recarga"},
        {llave: "nir", valor: "Nir"},
        {llave: "plataforma", valor: "plataforma"},
      ],
      titulosBisvi: [
        {llave: "icc", valor: "Icc"},
        {llave: "dn", valor: "DN"},
        {llave: "monto", valor: "Monto"},
        {llave: "lider", valor: "Lider"},
        {llave: "cliente", valor: "Cliente"},
        {llave: "compania", valor: "compañia"},
        {llave: "subidoPor", valor: "Subido por"},
        {llave: "fechaSubida", valor: "Subida"},
        {llave: "fechaActualizacion", valor: "Actualizada"},
        {llave: "fechaVigencia", valor: "Vigencia"},
        {llave: "fechaRecarga", valor: "Recarga"},
        {llave: "nir", valor: "Nir"},
        {llave: "plataforma", valor: "plataforma"},
        {llave: "fechaEntrega", valor: "entregada"},
        {llave: "producto", valor: "producto"},
        {llave: "fechaPortada", valor: "portada"},
      ],
      mostrarExcel: false,
      nirEditar: "",
      cuerpos: [],
      filaEditar: "0",
      iccEdit: "",
      dnEdit: "",
      montoEdit: "",
      liderEdit: "",
      clienteEdit: "",
      miNivel: "",
      isPlataforma: false,
      isBisvi: false,
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
      mostrarFiltros: true,
      permisoDesbloquear: false,
      fechaIni: "",
      fechaFin: "",
      isMonto: true,
      idEditar: '',
      googleCode: '',
      latitude: '',
      longitude: '',
      empresa: window.localStorage.getItem('empresa')
    };
  },
  methods: {

    showModal(event, id){
      if(this.miNivel==1 && (
          this.empresa != 'demo'
      )){
        console.log(`emit`)
        this.idEditar= id
        setTimeout(() => $("#modalEliminarUsuario").modal("close"), 1);
        emitter.emit('showModal', {event});
      }
      else {
        if(event == 'editarIcc' ) this.guardar(id)
        }
    },

    fIsControler(ruta) {
      if (this.miNivel != 1) {
        console.log(`en le nivel`)
        return false
      }
      const empresa = controles[`${this.empresa}`]
      if (!empresa) {
        console.log(`en la empresa`)
        return true
      }
      const user = empresa.find(e => e.user == localStorage.username)
      if (!user) {
        console.log(`en el user`)
        return true
      }
      const rutaValida = user.rutas.find(r => r == ruta)
      if (rutaValida) {
        console.log(`en la ruta`)
        return false
      }

      return true
    },
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
          })
      );
    },
    initChips() {
      if (this.isBisvi) {
        this.titulosBisvi.forEach((titulo) => {
          const elems = document.getElementById(titulo.llave);
          const chipsOptions = {
            ...this.chipsOptions,
            key: titulo.llave,
            placeholder: `${titulo.valor}`,
          };
          const chip = M.Chips.init(elems, chipsOptions);
        });
      } else {
        this.titulos.forEach((titulo) => {
          const elems = document.getElementById(titulo.llave);
          const chipsOptions = {
            ...this.chipsOptions,
            key: titulo.llave,
            placeholder: `${titulo.valor}`,
          };
          const chip = M.Chips.init(elems, chipsOptions);
        });
      }
    },

    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
          (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({key, value});
      console.log(this.chips);
    },

    generarExcel() {
      console.log("por generar excel loco");
      this.$store.commit("ponerBarra");

      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const fechas = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };
      console.log(`1132312321`);
      creaExcel(this.chips, "ADMINISTRAR", fechas)
          .then((response) => {
            this.$store.commit("quitarBarra");
            if (window.location.href.includes("recargasasec.com")) {
              console.log(process.env.NODE_ENV);

              window.location =
                  process.env.NODE_ENV == "productionCam"
                      ? `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            } else {
              window.location =
                  process.env.NODE_ENV === "production"
                      ? `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
            M.toast({
              html: "No se pudo crear el excel",
              classes: "rounded",
              displayLength: 3000,
            });
          });
    },
    traerIccs(contador, offset) {
      if (contador === 0) {
        this.datosRecibios = []
        this.datosAMostrar = []
      }
      console.log(`flaggg`);
      //console.log(31123312)
      console.log(contador, offset, `estoeoconewlikl `);
      console.log(document.getElementById("input-fecha-inicial"));
      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      if (!fechaIni) {
        const date = new Date();
        const dia = date.getDate() > 27 ? 27 : date.getDate();
        const mes =
            date.getMonth() == 0
                ? 11
                : date.getMonth() == 1
                ? 12
                : date.getMonth() - 1;
        const anio =
            date.getMonth() == 0 || date.getMonth() == 1
                ? date.getFullYear() - 1
                : date.getFullYear();
        fechaIni = `${anio}/${mes}/${dia}`;
        if (!window.location.href.includes("recargasasec.com"))
          document.getElementById("input-fecha-inicial").value = fechaIni;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()}`;
        // if (!window.location.href.includes("recargasasec.com"))
        document.getElementById("input-fecha-final").value = fechaFin;
      }
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }

      this.$store.commit("ponerBarra");

      let defaults;
      let plataformas, plataformasC;
      getEmpresas()
          .then((resp) => {
            defaults =
                resp.data.noPlataforma == 2
                    ? `${resp.data.usuario2} (${resp.data.plataforma2})(General)`
                    : `${resp.data.usuario} (${resp.data.plataforma})(General)`;
            return plataformasEmpresa();
          })
          .then((resp) => {
            //console.log(resp, 123123)
            plataformas = resp.data;

            return plataformaCarrier();
          })
          .then((resss) => {
            plataformasC = resss.data;
            if (window.location.href.includes("recargasasec.com"))
              return getIccs(contador, offset);
            else
              return getIccs(
                  contador,
                  offset,
                  diaIni,
                  mesIni,
                  anioIni,
                  diaFin,
                  mesFin,
                  anioFin
              );
          })
          .then((response) => {

            console.log(response, `esta es la eresp[k`);
            this.isPlataforma = response.titulos.find(
                (t) => t.llave == `plataforma`
            )
                ? true
                : false;
            this.miNivel = localStorage.nivel + "";
            if (this.miNivel != 1) {
              this.isPlataforma = false;
            }

            copyTitulos = response.titulos.slice();
            response.titulos.forEach((titulo) => (filtros[titulo.llave] = ""));

            if (this.isPlataforma)
              response.iccs = response.iccs.map((i) => {
                const auxcomp = i.compania;
                const comp = i.compania.split(" ");
                i.compania = comp[0];
                let c = `T`;
                if (i.compania == `Movistar`) c = `M`;
                if (i.compania == `AT&T`) c = `A`;
                if (i.compania == `Unefon`) c = `U`;
                i.compania = auxcomp;
                //console.log(i.plataforma)
                //console.log(plataformas);
                const plataformaAux = plataformas.find(
                    (p) => p.id == i.plataforma
                );
                const plataformaAux2 = plataformasC.find((p) => p.carrier == c)
                    ? plataformasC.find((p) => p.carrier == c)
                    : defaults;
                const plataformaAux3 = plataformaAux
                    ? plataformaAux
                    : plataformas.find(
                        (p) => p.id == plataformaAux2.empresaPlataformaId
                    );
                const typeaux = plataformaAux ? `(Archivo)` : `(Carrier)`;
                if (i.dn == 5634098121)
                  console.log(
                      `4645465465`,
                      plataformaAux2,
                      plataformaAux3,
                      plataformas,
                      i
                  );
                const plataforma = plataformaAux3
                    ? `${plataformaAux3.plataforma}(${plataformaAux3.usuario})${typeaux}`
                    : `No aplica ${defaults}`;
                return {
                  ...i,
                  plataforma,
                };
              });

            this.datosRecibios = this.datosRecibios.concat(response.iccs.slice());
            usuario = localStorage.id;
            this.datosAMostrar = this.datosAMostrar.concat(response.iccs.slice());


            // this.datosRecibios = response.iccs.slice();
            // usuario = localStorage.id;
            // this.datosAMostrar = response.iccs.slice();
            console.log(this.datosRecibios.length, `datso a smosskj`);
            this.titulo = `${this.datosRecibios.length} encontrados`;
            /*         this.agregar100(); */
            if (response.iccs.length > 0) {
              this.traerIccs(++contador)
            } else {
              console.log("se quita barra");
              this.$store.commit("quitarBarra");
              $(".input-filtros").prop("disabled", false);
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
          });
    },

    traerIccsFechas(contador, offset) {
      //console.log(31123312)
      console.log(contador, offset);
      /*       if (contador === 1) this.agregar100(); */
      if (contador === 0) {
        this.datosAMostrar = [];
        this.datosRecibios = [];
      }
      //console.log(this.datosRecibios.length, this.datosAMostrar.length, `los datos`)
      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let initialDate = new Date(fechaIni);
      let finalDate = new Date(fechaFin);
      // console.log(`initialDate: `, initialDate, `finalDate: `, finalDate);
      let actualDate = new Date();
      let fechasDif = finalDate - initialDate;
      // if (!window.location.href.includes("recargasasec.com")) {
      //   if (fechasDif > 400 * 24 * 60 * 60 * 1000) {
      //     // console.log("El rango supera los 90 días");
      //     this.showMessageRange = true;
      //     this.$refs.modal.openModal();
      //   } else this.showMessageRange = false;
      //
      //   if (actualDate - initialDate > 400 * 24 * 60 * 60 * 1000) {
      //     // console.log(`La fecha inicial supera el año de antiguedad`);
      //     this.showMessageOld = true;
      //     this.$refs.modal.openModal();
      //   } else this.showMessageOld = false;
      //   if (this.showMessageOld || this.showMessageRange) return;
      // }

      if (!fechaIni) {
        const date = new Date();
        const dia = date.getDate() > 27 ? 27 : date.getDate();
        const mes =
            date.getMonth() == 0
                ? 11
                : date.getMonth() == 1
                ? 12
                : date.getMonth() - 1;
        const anio =
            date.getMonth() == 0 || date.getMonth() == 1
                ? date.getFullYear() - 1
                : date.getFullYear();
        fechaIni = `${anio}/${mes}/${dia}`;
        document.getElementById("input-fecha-inicial").value = fechaIni;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()}`;
        document.getElementById("input-fecha-final").value = fechaFin;
      }
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }

      this.$store.commit("ponerBarra");

      let defaults;
      let plataformas, plataformasC;
      getEmpresas()
          .then((resp) => {
            defaults =
                resp.data.noPlataforma == 2
                    ? `${resp.data.usuario2} (${resp.data.plataforma2})(General)`
                    : `${resp.data.usuario} (${resp.data.plataforma})(General)`;
            return plataformasEmpresa();
          })
          .then((resp) => {
            plataformas = resp.data;

            return plataformaCarrier();
          })
          .then((resss) => {
            plataformasC = resss.data;
            return getIccs(
                contador,
                offset,
                diaIni,
                mesIni,
                anioIni,
                diaFin,
                mesFin,
                anioFin
            );
          })
          .then((response) => {
            this.$store.commit("quitarBarra");
            /*     this.titulos = response.titulos.slice(); */
            this.isPlataforma = response.titulos.find(
                (t) => t.llave == `plataforma`
            )
                ? true
                : false;
            this.miNivel = localStorage.nivel + "";
            if (this.miNivel != 1) {
              this.isPlataforma = false;
            }

            copyTitulos = response.titulos.slice();
            response.titulos.forEach((titulo) => (filtros[titulo.llave] = ""));
            console.log(defaults);
            if (this.isPlataforma)
              response.iccs = response.iccs.map((i) => {
                const auxcomp = i.compania;
                const comp = i.compania.split(" ");
                i.compania = comp[0];
                let c = `T`;
                if (i.compania == `Movistar`) c = `M`;
                if (i.compania == `AT&T`) c = `A`;
                if (i.compania == `Unefon`) c = `U`;
                i.compania = auxcomp;
                const plataformaAux = plataformas.find(
                    (p) => p.id == i.plataforma
                );
                const plataformaAux2 = plataformasC.find((p) => p.carrier == c)
                    ? plataformasC.find((p) => p.carrier == c)
                    : defaults;
                const plataformaAux3 = plataformaAux
                    ? plataformaAux
                    : plataformas.find(
                        (p) => p.id == plataformaAux2.empresaPlataformaId
                    );
                const typeaux = plataformaAux ? `(Archivo)` : `(Carrier)`;

                const plataforma = plataformaAux3
                    ? `${plataformaAux3.plataforma}(${plataformaAux3.usuario})${typeaux}`
                    : `No aplica ${defaults}`;
                return {
                  ...i,
                  plataforma,
                };
              });
            this.datosRecibios = this.datosRecibios.concat(response.iccs.slice());
            usuario = localStorage.id;
            this.datosAMostrar = this.datosAMostrar.concat(response.iccs.slice());

            this.titulo = `${this.datosRecibios.length} encontrados`;
            //this.agregar100()
            console.log(
                this.datosAMostrar.length,
                this.datosRecibios.length,
                response.iccs.length
            );
            if (response.iccs.length > 0) {
              this.traerIccsFechas(++contador);
            } else {
              this.$emit("quitarBarra");
              $(".input-filtros").prop("disabled", false);
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
          });
    },
    editar(fila) {
      this.filaEditar = fila.id;
      this.iccEdit = fila.icc;
      this.dnEdit = fila.dn;
      this.liderEdit = fila.lider;
      this.clienteEdit = fila.cliente;
      this.montoEdit = fila.monto;
      this.companiaEdit = fila.compania;
      this.nirEditar = fila.nir;
      setTimeout(() => {
        M.updateTextFields();
      }, 100);
    },
    guardar(id) {

      console.log(`se esta guardando`)
      if (this.iccEdit.length < 1 || this.dnEdit.length < 1)
        return M.toast({
          html: "Ningun campo puede ir vacio",
          classes: "rounded",
          displayLength: 4000,
        });
      if (
          this.iccEdit.length < 19 ||
          this.iccEdit.length > 19 ||
          isNaN(Number(this.iccEdit))
      )
        return M.toast({
          html: "Icc invalido",
          classes: "rounded",
          displayLength: 4000,
        });
      console.log(
          this.dnEdit.length < 10 || isNaN(Number(this.dnEdit)),
          !this.nirEditar
      );
      if (
          (this.dnEdit.length < 10 || isNaN(Number(this.dnEdit))) &&
          !this.nirEditar
      )
        return M.toast({
          html: "Dn invalido",
          classes: "rounded",
          displayLength: 4000,
        });
      this.$store.commit("ponerBarra");
      actualizarIcc(
          id,
          this.iccEdit,
          this.dnEdit,
          this.companiaEdit,
          this.liderEdit,
          this.montoEdit,
          this.clienteEdit,
          this.nirEditar,
          this.latitude,
          this.longitude,
          this.googleCode,
      )
          .then((respuesta) => {
            this.isEdit = false;
            this.filaEditar = "0";
            this.datosAMostrar = [];
            this.datosRecibios = [];
            this.traerIccs(0);
            // document.getElementById("player").play();
            M.toast({
              html: "Actualizado correctamente",
              classes: "rounded",
              displayLength: 4000,
            });
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("quitarBarra");
            // document.getElementById("player").play();
            M.toast({
              html: "Error actializando, intente de nuevo mas tarde",
              classes: "rounded",
              displayLength: 4000,
            });
          });
    },

    desbloquear(icc) {
      const iccAux = icc;
      console.log(`icc: `, icc);
      activateLine({store: this.$store}, iccAux)
          .then(() => {
            this.datosAMostrar.find((d) => d.icc == icc).isRecargado = "0";
            M.toast({
              html: "Línea desbloqueada",
              classes: "rounded",
              displayLength: 4000,
            });
          })
          .catch((error) => {
            console.log(error);
            M.toast({
              html: "Error activando, intente de nuevo mas tarde",
              classes: "rounded",
              displayLength: 4000,
            });
          });
    },
    /*     filtro(key, evento) {
      filtros[key] = evento.target.value.toLowerCase();
      this.cuerpos = [];
      this.datosAMostrar = this.datosRecibios.slice();
      Object.keys(filtros).forEach((llave) => {
        const auxFiltro = filtros[llave];
        if (auxFiltro !== "") {
          this.datosAMostrar = this.datosAMostrar.filter((fila) =>
            fila[llave]
              .toLowerCase()
              .split(" ")
              .some((word) => word.includes(auxFiltro))
          );
        }
      });
      this.titulo = `${this.datosAMostrar.length} encontrados`;
      this.agregar100();
    }, */
  },
  computed: {
    ...mapState(["permisos", "isAdmin"]),
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();
      console.log(this.titulo);
      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
              auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {
              return item[titulo.key]
                  .toUpperCase()
                  .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
        console.log("Termino");
        console.log(this.datosAMostrar.length);
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
  },
  created() {
    if (usuario !== localStorage.id) {
      this.cuerpos = [];
      this.datosAMostrar = [];
      this.datosRecibios = [];
    }
  },
  beforeDestroy(){
    emitter.off('enviarCodigo')
  },
  mounted() {

    emitter.on('enviarCodigo', (data) => {
      console.log(data, `emiter`)
      this.latitude = data.latitude
      this.longitude = data.longitude
      this.googleCode = data.googleCode

      if(data.event == "editarIcc") {
        this.guardar(this.idEditar)
        this.idEditar = ''
      }

    });

    this.miNivel = localStorage.nivel;
    const permisos = `${localStorage.permisos}`;
    this.isMonto = localStorage.isMonto == 0 ? false : true
    console.log(`miNivel: `, this.miNivel);
    this.isBisvi =
        permisos.includes(`BISVI`) && this.miNivel == 1 ? true : false;
    console.log(permisos, `los permisos`)
    this.permisoDesbloquear =
        permisos.includes(`DESBLOQUEAR_LINEAS`) && this.miNivel == 1
            ? true
            : false;
    console.log(this.permisoDesbloquear, `los permisos`)
    if (localStorage.empresa == 'gsmoviles' || localStorage.empresa == 'teletrial') {
      console.log(`no estras`)
      this.permisoDesbloquear = this.permisoDesbloquear && (localStorage.username == 'administrador' || localStorage.username == 'cesar' || localStorage.username == 'gsmoviles')
    }

    console.log(`isBisvi: `, this.isBisvi);
    this.$nextTick(() => {
      setTimeout(() => {
        M.AutoInit()
        this.initChips();
        console.log(`aqui empieza`);
        const fechaInicialInput = document.querySelector(
            "#input-fecha-inicial"
        );
        const fechaFinalInput = document.querySelector("#input-fecha-final");

        M.Datepicker.init(fechaInicialInput, {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            // Llama a consultar cuando se cierra el datepicker de fecha inicial
            this.traerIccsFechas(0, 0);
          },
        });

        M.Datepicker.init(fechaFinalInput, {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            // Llama a consultar cuando se cierra el datepicker de fecha final
            this.traerIccsFechas(0, 0);
          },
        });

        M.updateTextFields();

      }, 1000);

      console.log(`aqui termina`);
      this.traerIccs(0, 0);
      $(window).scroll(() => {
        if ($(document).height() < $(window).scrollTop() + $(window).height() + 50) {
          /*    this.agregar100(); */
          this.indexScroll++;
        }
      });
    });
  },
  updated() {
    // M.AutoInit();
  },
  components: {ModalVentas},
};
</script>

<style scoped>
.datepicker {
  border-bottom: none !important;
}

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

.btn {
  width: 70px;
  text-align-last: center;
}

.btn-style {
  margin-top: 5px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #aeafb7;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #656772;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #aeafb7;
}

.table-responsive {
  display: block;
  overflow-x: auto;
  width: 100%;
  text-align-last: center;
}

.table {
  padding: 0px !important;
  font-size: 0.9rem;
}

@media screen and (max-width: 600px) {
  table.striped.highlight th {
    font-size: 14px;
    white-space: nowrap;
  }
}

* {
  box-sizing: border-box !important;
}

.search-box {
  width: fit-content !important;
  height: fit-content !important;
  position: relative !important;
}

.input-search {
  height: 50px !important;
  width: 50px !important;
  border-style: none !important;
  padding: 10px !important;
  font-size: 18px !important;
  letter-spacing: 2px !important;
  outline: none !important;
  border-radius: 25px !important;
  transition: all 0.5s ease-in-out !important;
  background-color: #22a6b3 !important;
  padding-right: 40px !important;
  color: black !important;
}

.input-search::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
  font-size: 18px !important;
  letter-spacing: 2px !important;
  font-weight: 100 !important;
}

.input-search:focus {
  width: 300px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  transition: all 500ms cubic-bezier(0, 0.11, 0.35, 2) !important;
}

.icon-chips {
  font-size: 15px;
}

.titulo {
  font-size: 2.5em;
  font-family: "Roboto", serif;
  font-weight: lighter;

  border-radius: 1rem;

  margin-top: 5px;
}

.titulo-card {
  font-size: 2.5em;
  font-family: "Roboto", serif;
  margin-bottom: 10px;
}

table {
  background-color: #ffffff;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}

td,
th {
  padding: 15px 5px;
  display: table-cell;
  text-align: center !important;
  vertical-align: middle;
  border-radius: 2px;
}

/*.input-field {*/
/*  margin: 0;*/
/*}*/

.margen-titulo {
  margin-bottom: 12px;
}

.material-symbols-outlined {
  line-height: normal;
}

.fixed-action-btn {
  top: 80px;
}

.fuenteVerde {
  color: #00b134;
}

.fa-ban {
  color: #aaaaaa;
}

.fuenteRojo {
  color: #d60100;
}

.fuenteGuardar {
  background-color: #7a0f19;
  color: white;
}

.fa {
  font-size: 1.4em;
}

/*.modal {*/
/*  min-height: 80%;*/
/*}*/

/*.input-field {*/
/*  min-height: 50px;*/
/*}*/

.titulo-card {
  font-size: 1.2em;
}

.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}

.button-box .button-box-int {
  align-items: start;
  display: inline-flex;
  flex-wrap: wrap;
  height: 50px;
}

.button-container .btn-large i.material-icons {
  margin-right: 8px;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }

  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}

.cursorOn {
  color: #084c63;
  cursor: pointer;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}

.input-date {
  margin: 0.7rem 0 0 0;
}


.row {
  padding: 1rem;
}


</style>
